import { render } from "./PinConfirmation.vue?vue&type=template&id=6d04d115"
import script from "./PinConfirmation.vue?vue&type=script&lang=js"
export * from "./PinConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__